<template>
  <svg
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.585 0L11 8.39667L19.415 0L22 2.585L11 13.585L0 2.585L2.585 0Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "IconDownArrow",
};
</script>

<style></style>
